<template>
  <teleport to="body">
    <base-modal
      ref="modal"
      id="changePasswordModal"
      :title="$t('default.profile.change-password')"
      size="sm">
      <template v-slot:body>
        <div class="row">
          <div class="form-group col-12">
            <label class="label" for="old_password">{{ $t('default.profile.current-password') }}</label>
            <input v-model="form.old_password" type="text" class="form-control" id="old_password" />
          </div>
          <div class="form-group col-12">
            <label class="label" for="new_password">{{ $t('default.profile.new-password') }}</label>
            <input v-model="form.new_password" type="text" class="form-control" id="new_password" />
          </div>
          <div class="form-group col-12">
            <label class="label" for="new_password_confirmation">{{ $t('default.profile.new-password-confirmation') }}</label>
            <input v-model="form.new_password_confirmation" type="text" class="form-control" id="new_password_confirmation" />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button @click="handleSave" class="btn btn-primary me-2">{{ $t('default.save') }}</button>
        <button @click="close" class="btn btn-secondary">{{ $t('default.close') }}</button>
      </template>
    </base-modal>
  </teleport>
</template>

<script>
import BaseModal from '../../../components/shared/components/UI/BaseModal'
import UserResource from '../../../api/userResource'

const resource = new UserResource()

export default {
  name: 'ChangePasswordModal',

  components: { BaseModal },

  data () {
    return {
      loading: false,
      form: {
        old_password: '',
        new_password: '',
        new_password_confirmation: ''
      }
    }
  },

  methods: {
    handleSave () {
      resource.changePassword(this.form)
        .then(() => {
          this.$helpers.notifySuccessMessage(this.$t('default.profile.successfully-updated'))
          this.close()
        })
        .catch(err => {
          this.$helpers.notifyErrorMessage(err)
        })
    },

    async open () {
      this.$refs.modal.open()
    },

    close () {
      this.$refs.modal.close()
    }
  }
}
</script>
